export enum Event {
  CLOSE = "close",
  COMPLETED = "completed",
  ERROR = "error",
  TOKEN_EXPIRED = "token_expired"
}
